var _path, _g, _path2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrokenCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6702_31044",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 12,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5055 14.9408L20.3525 12.2678L29.2854 13.3646L27.8229 25.2752L19.8826 24.3002L16.8352 20.3998L20.6747 17.8487L17.5055 14.9408Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6702_31044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.2977,
    y: 12.1636,
    width: 17,
    height: 10,
    rx: 1,
    transform: "rotate(7 11.2977 12.1636)",
    fill: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9325,
    y: 15.1411,
    width: 17,
    height: 2,
    transform: "rotate(7 10.9325 15.1411)",
    fill: "#F6F7FA"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_6702_31044",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 12,
    width: 13,
    height: 14
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9452 12.1818L7 13.2271L8.25434 25.1613L19.1941 24.0115L15.3474 20.8965L18.5146 17.5471L14.7725 15.4267L16.9452 12.1818Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_6702_31044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8.09863,
    y: 14.1169,
    width: 17,
    height: 10,
    rx: 1,
    transform: "rotate(-6 8.09863 14.1169)",
    fill: "#C4CBDC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.41223,
    y: 17.1006,
    width: 17,
    height: 2,
    transform: "rotate(-6 8.41223 17.1006)",
    fill: "#F6F7FA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenCardIcon);
export default __webpack_public_path__ + "static/media/brokenCardIcon.6b976d4f36dbfac76ab06b7fd328714e.svg";
export { ForwardRef as ReactComponent };